export const roundFloat = (float: number, accuracy: number = 4) =>
  parseFloat(float.toFixed(accuracy)).toString();
